import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { PropertySale } from '@eemo/api-client';
import { SaleUpdateStatusDialogData } from '../sale-update-status-dialog/sale-update-status-dialog.component';
import { SalePlayerAssociationComponent } from '../sale-player-association/sale-player-association.component';
import { NgTemplateOutlet } from '@angular/common';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';

export class SaleUpdatePlayersDialogData {
  sale: PropertySale;
}

@Component({
    selector: 'app-sale-update-players-dialog',
    templateUrl: './sale-update-players-dialog.component.html',
    styleUrls: ['./sale-update-players-dialog.component.scss'],
    standalone: true,
    imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, SalePlayerAssociationComponent]
})
export class SaleUpdatePlayersDialogComponent implements OnInit, OnDestroy {
  dialogTitle: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SaleUpdateStatusDialogData,
    public dialogRef: MatDialogRef<SaleUpdatePlayersDialogComponent>,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.dialogTitle = 'salePlayersDialog.title';
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
